<template>
  <app-content class="h-panel">
    <Tabs :datas="datas" v-model="selected" class="px-16px"></Tabs>
    <component :is="selected"/>
  </app-content>
</template>

<script>
import CheckList from "@/views/checkout/CheckList";
import UnCheckOut from "@/views/checkout/UnCheckOut";

export default {
  name: "Checkout",
  components: {UnCheckOut, CheckList},
  data() {
    return {
      datas: [{
        title: '期末处理',
        key: 'CheckList'
      }, {
        title: '反结账',
        key: 'UnCheckOut'
      }
      // , {
      //   title: '结转模板',
      //   key: 'CheckTemplate'
      // }
      ],
      selected: 'CheckList'
    }
  }
}
</script>
